export default __webpack_public_path__ + "static/media/Group 236(1).f0f7f782.png";